import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image/withIEPolyfill';
import './imageMedia.css';

export const LogoImage = () => {
  const {
    logoImage,
  } = useStaticQuery(
    graphql`
      query {
        logoImage: file(relativePath: { eq: "logo_white2x.png" }) {
          childImageSharp {
            fluid(maxWidth: 337, quality: 100) {
             ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `);

  return (
    <>
      <Img
        Tag={'span'}
        fluid={logoImage.childImageSharp.fluid}
        className={'logo'}
        objectFit="contain"
        alt="Bluevalue"
      />
    </>
  );
};
